/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-06 09:36:25
 * @LastEditTime: 2020-08-11 11:48:29
 * @Description: 复配公司api
 */
import axios from '@/utils/axios'

export const getSacCompanys = (payload) => {
    return axios.get('/sacCompany', {
        params: payload
    })
}

export const updateSacCompany = (id, data) => {
    return axios.put(`/sacCompany/${id}`, data);
}

export const createSacCompany = (data) => {
    return axios.post(`/sacCompany`, data)
}

export const deleteSacCompany = (id) => {
    return axios.delete(`/sacCompany/${id}`)
}